import { Model } from '../parents/model';

export class EnumeratorModel extends Model {
  // PAYMENT METHODS
  static ATTR_PAYMENT_SERVICE = 'payment_service';

  // ORDERS
  static ATTR_THIRD_PARTY_SERVICE = 'third_party_service';

  // ORDER FILES
  static ATTR_ORDER_FILE_TYPE = 'order_file_type';

  // PAYMENT METHODS
  get paymentService() {
    return this.attributes[EnumeratorModel.ATTR_PAYMENT_SERVICE];
  }

  // ORDERS
  get thirdPartyService() {
    return this.attributes[EnumeratorModel.ATTR_THIRD_PARTY_SERVICE];
  }

  // ORDER CREDIT STATES
  get orderCreditState() {
    return this.attributes[EnumeratorModel.ATTR_ORDER_CREDIT_STATE];
  }

  /**
   * @param {Model} model
   */
  update(model) {
    Object.keys(model.attributes).forEach(attribute => {
      if (!this.attributes[attribute]) {
        this.attributes[attribute] = model.attributes[attribute];
      }
    });
  }
}
